import { ContainerModule } from 'inversify';
import { AspectService, AspectServiceSymbol } from './aspect-service';
import { CourseService, CourseServiceSymbol } from './course-service';
import { UpdateSelectedChapter } from './listeners/update-selected-chapter';
import { EventStreamListenerSymbol } from '@/app/event-stream';

export const aspectModule = new ContainerModule((bind) => {
  bind<AspectService>(AspectServiceSymbol).to(AspectService);
  bind<CourseService>(CourseServiceSymbol).to(CourseService);

  bind(UpdateSelectedChapter).toSelf().inSingletonScope();
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(UpdateSelectedChapter));
});
